import { Component, ViewChild, ElementRef  } from '@angular/core';
import { NavController,NavParams,AlertController,ViewController,App,LoadingController, Loading} from 'ionic-angular';

import { ListPage } from '../../pages/list/list';
import { AuthService } from '../../providers/auth';
import { RidePage } from '../../pages/ride/ride';
import { StarRatingModule } from 'ionic3-star-rating';

import { Events } from 'ionic-angular';
@Component({
  selector: 'page-rate',
  templateUrl: 'rate.html'
})
export class RatePage {
  loading: Loading;
  savedata: boolean = false;
  drivestartbtn:boolean=true;
  dropbtn:boolean=true;
  tab1Root: any = ListPage;
  tab2Root: any = ListPage;
  pet:any;
  rating=0;
  selectedItem: any;
  obj:any;
  obj2:any;
  obj3:any;
  items;
  items2;
  items3;
 message;
 driver_recommend;
 service_recommend;
 ratingsts=2;
routeResponse;
getrate;
 //  @ViewChild(Tabs) tabs;
 

  constructor(public loadingCtrl: LoadingController,private alertCtrl: AlertController,public navCtrl: NavController,public authService:AuthService,public navParams: NavParams, public events: Events) {

   this.items = navParams.get('data');

    events.subscribe('star-rating:changed', (starRating) => {

     this.rating=starRating;

    console.log(starRating)

    });
  
  }

  ratenow(){
  if(this.rating>0){

    let updaterate={"company_id":localStorage.getItem('company_id'),"driver_id":this.items.driver_id,"order_id":this.items.order_id,"rating_value":this.rating,'message':this.message,"recommdriver":this.driver_recommend,"recommservice":this.service_recommend}
            let data_parameters=updaterate;
            let method='ratings.php';
          
            this.authService.postData(data_parameters,method).then((result) => {
             
              this.obj = result;
              console.log(this.obj);
              
             if(this.obj.status=='true'){
             //alert(this.obj.message);
             this.savedata=false;
              }
             
             else{

           
              }
              
              }, (err) => {
                // Error log
            }); 
            }
            else{
            alert('Bitte Sterne für Bewertung klicken');
            }

  }
  

  
  ionViewDidEnter() {

 let getrate={"company_id":localStorage.getItem('company_id'),"order_id":this.items.order_id}

    let data_parameters=getrate;
console.log(data_parameters);
  let method='get_rating.php';

  this.authService.postData(data_parameters,method).then((result) => {
 
    this.obj = result;
    console.log(this.obj);
    
   if(this.obj.status=='true'){

   this.savedata=false;

     this.message=this.obj.response.message;
     this.rating=this.obj.response.order_ration;
 
    }
   
   else{

 this.savedata=true;
    }
    
    }, (err) => {
      // Error log
  });



// this.rating= this.items.rating_value;
   // console.log(this.items);


}
 



}



// WEBPACK FOOTER //
// ./src/pages/rate/rate.ts